import * as React from "react";
import { FormattedMessage } from "react-intl";
import { animated, useSpring } from "react-spring";
import { Button } from "@components/atoms";
import "./scss/index.scss"; // const favoritesImage = require("../../images/nav/favorites.svg");

var ArrivedButtons = function ArrivedButtons(_ref) {
  var undeliveredClick = _ref.undeliveredClick,
      deliveredClick = _ref.deliveredClick;
  var scaleButton = useSpring({
    config: {
      friction: 40,
      mass: 5,
      tension: 350
    },
    from: {
      scale: 1.1
    },
    loop: true,
    to: {
      scale: 1
    }
  });
  return React.createElement("footer", {
    className: "footerDelivery"
  }, React.createElement("div", {
    className: "footerDelivery__left"
  }, React.createElement(Button, {
    type: "button",
    testingContext: "",
    onClick: undeliveredClick
  }, React.createElement(FormattedMessage, {
    id: "components.FooterDelivery.ArrivedButtons.3853742296",
    defaultMessage: "Undelivered"
  }))), React.createElement("div", {
    className: "footerDelivery__right"
  }, React.createElement(animated.button, {
    className: "footerDelivery__text",
    type: "button",
    onClick: deliveredClick,
    style: scaleButton
  }, React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "components.FooterDelivery.ArrivedButtons.1464199760",
    defaultMessage: "Delivered"
  })))));
};

export default ArrivedButtons;